// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"ebf67360","233":"84a1e720","288":"ca88d73b","327":"af7f154e","401":"8f4c2194","641":"d64d6db8","673":"08e811a0","852":"aa8a421b","874":"1ccf658d"}[chunkId] + ".chunk.js";
};